<script>
import Svc from "@/services/payments-service";
import Repo from "@/models/PaymentRepo"
import FormErrors from '@/util/form-errors';
import errorsMixin from '@/mixins/errors.mixin';
import { PaymentCustom, PAYMENT_STATUS, PaymentLog } from '../../../../../../models/paymentModel';
import PaymentsValidator from "@/models/PaymentValidator"

export default {
  render() {
    return this.$scopedSlots.default({
      list: this.list,
      listLoading: this.listLoading,
      loadData: this.loadData,
      showing: this.showing,
      toggle: this.toggle,
      formErrors: this.formErrors,
      setNewEditor: this.setNewEditor,
      create: this.validateCreation,
      processing: this.processing,
      ID: this.ID,
      logs: this.logs,
      updateCanceledLog: this.updateCanceledLog
    })
  },

  mixins: [errorsMixin],

  props: {
    getLogs: Function,
    model: Object
  },

  data: () => ({
    showing: false,
    svc: new Svc(
      new Repo()
    ),
    list: [],
    logs: [],
    listLoading: false,
    ID: null,
    candidate: {},
    formErrors: new FormErrors(),
    editorData: new PaymentCustom(),
    processing: false
  }),

  mounted() {
    // this.loadData()
  },

  methods: {
    async loadData(params = {cache: false}) {
      this.listLoading = true
      let [list] = await Promise.all([this.loadList({cache: params.cache})])
      this.list = list
      // this.loadLogs()
      this.listLoading = false
    },

    async loadList(params = {cache: false}) {
      try {
        let res = await this.svc.list(params)
        return res
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    validateCreation(data) {
      if(!this.candidate.candidateEmail) 
        return this.$notify({text: 'No candidate email', type: 'error'})
      if(!data.systemPayment) {
        if(!this.isValid(data))
          return this.$notify({text: 'invalid field', type: 'error'})
      }
      this.create(data)
    },

    isValid(payment) {
      let paymentValidator = new PaymentsValidator(payment, this.formErrors)
      return paymentValidator.validate()
    },

    async create(data) {
      try {
        this.processing = true
        let res = await this.svc.create(this.ID, data)
        this.toggle()
        this.logs.unshift(new PaymentLog(res))
        this.$notify({text: 'Payment created', type: 'success'})
        return res
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      finally {
        this.processing = false
      }
    },

    saveCandidateAndOpen(data) {
      this.ID = data.ID,
      this.candidate = data
      this.logs = data.payments
      this.open()
    },

    open() {
      this.loadData()
      this.toggle()
    },

    setNewEditor() {
      this.editorData = new PaymentCustom({
        label: 'Custom'
      })
    },

    toggle() {
      this.showing = !this.showing
    },

    loadLogs() {
      this.logs = this.getLogs()
    },

    updateCanceledLog(ID) {
      let logIndex = this.logs.findIndex(log => log.ID === ID)
      if(logIndex > -1) this.logs[logIndex].status = PAYMENT_STATUS.CANCELED
    }
  },
}
</script>